import { UserModule } from '@/store/modules/user';
import request from '@/utils/request';

export function getTimSign(params: any) {
  return request({
    url: 'Third/timSign',
    method: 'get',
    params
  });
}

export const neteaseImLogin = (data: any) =>
  request({
    url: 'Third/neteaseImLogin',
    method: 'post',
    data
  });

export function getSpeech(params: any) {
  return request({
    url: 'Third/speechAudio',
    method: 'get',
    params
  });
}
export function getQiniuToken(params: any) {
  params.user_id = UserModule.getUserId;
  return request({
    url: 'Third/qiniu',
    method: 'get',
    params: params
  });
}
